import { FunctionComponent } from 'react';

interface Props {
  headers: string[];
  data: string[][];
}

const Table: FunctionComponent<Props> = ({ headers, data }) => {
  return (
    <div
      className="py-2 px-4 w-full overflow-x-auto scrollbar-thin scrollbar-thumb-slate-700
    scrollbar-track-gray-900 mb-2"
    >
      <table className="font-mono text-sm table-fixed box-border border-collapse border mb-2">
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th
                className="border border-slate-600 text-left p-1 break-words overflow-hidden text-[0.7rem] leading-[1rem] min-w-[4rem]"
                key={index}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {row.map((col, colIndex) => (
                <td
                  className="border border-slate-600 p-1 break-words overflow-hidden text-[0.7rem] leading-[1rem]"
                  key={`${index}-${colIndex}`}
                >
                  {col}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
